import * as React from "react";
import type { SVGProps } from "react";
const SvgIconHomeChimney = (props: SVGProps<SVGSVGElement>) => (
  <svg
    viewBox="0 0 24 24"
    fill="none"
    role="img"
    focusable="false"
    width="100%"
    height="100%"
    {...props}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.8 1.62c-.16.03-.24.08-.39.2l-9.15 8.4c-.36.39-.6.89-.65 1.4-.04.32-.03 8.34 0 8.62q.11.9.76 1.5.58.55 1.4.65c.28.04 16.18.04 16.46 0q.43-.05.8-.24c.76-.36 1.26-1.07 1.36-1.92.04-.28.04-16.16 0-16.34q-.08-.41-.46-.62l-.13-.07h-5.28l-.1.06q-.23.12-.35.3c-.13.2-.14.25-.16.8l-.01.5-1.67-1.53c-.92-.84-1.71-1.56-1.77-1.6-.18-.12-.43-.16-.65-.11M7.87 7.4l-4.3 3.96c-.12.13-.18.2-.2.3-.05.1-.05.47-.04 4.31v4.2l.07.13q.12.2.34.32l.1.06h7.3l.01-2.84v-2.85l.08-.15c.1-.24.31-.42.55-.48.42-.11.83.09 1.01.48l.07.15v2.85l.02 2.85h3.65l3.65-.01.1-.06q.22-.11.34-.32l.07-.13v-4.2c0-4.81.03-4.33-.23-4.6-.17-.17-8.43-7.75-8.45-7.75zm9.78-1.73v.78l1.41 1.3c.78.7 1.46 1.33 1.52 1.4l.12.1V4.9h-3.05z"
      fill="currentColor"
    />
  </svg>
);
export default SvgIconHomeChimney;
